import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { noop } from 'lodash-es';
import { Box, Column } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useIsMobileForHomePage } from '~/hooks/useIsMobileForHomePage';
import { useOpenNewProposal } from '~/hooks/useOpenNewProposal';
import { useClientSummary } from '../../hooks/useClientSummary';
import { AgreementsOverviewCard } from './cards/AgreementsOverviewCard/AgreementsOverviewCard';
import { BillingOverviewCard } from './cards/BillingOverviewCard/BillingOverviewCard';
import { ContactsCard } from './cards/ContactsCard/ContactsCard';
import { ContactsCardOld } from './cards/ContactsCardOld/ContactsCardOld';
import { NeedsAttentionCard } from './cards/NeedsAttentionCard/NeedsAttentionCard';
import { useOpenAddPaymentMethodModal } from './cards/PaymentMethodsCard/AddPaymentMethodModal/hooks/useOpenAddPaymentMethodModal';
import { PaymentMethodsCard } from './cards/PaymentMethodsCard/PaymentMethodsCard';
import styles from './SummaryTab.module.scss';
export const GetSummaryTabTID = (parentTestId)=>getTestIds(parentTestId);
export function SummaryTab(param) {
    let { clientId, clientName, isArchived, onManageBilling, onViewUpcomingInvoice, onBillClient, onViewAllOverdue } = param;
    const { SummaryTabTestIds: TID } = useMemo(()=>GetSummaryTabTID(), []);
    const { summary } = useClientSummary(clientId);
    const { openNewProposal } = useOpenNewProposal({
        navigationState: {
            selectedClientId: clientId
        }
    });
    const isMobile = useIsMobileForHomePage();
    const openAddPaymentMethodModal = useOpenAddPaymentMethodModal(clientId);
    const { CRM_CONTACTS } = useFeatureFlags();
    return /*#__PURE__*/ _jsxs(Column, {
        testId: TID.Root(),
        gap: 24,
        className: styles.outer,
        children: [
            summary.needsAttention.length > 0 && /*#__PURE__*/ _jsx(Box, {
                testId: TID.NeedsAttentionSection(),
                className: styles.needsAttentionWrap,
                children: /*#__PURE__*/ _jsx(NeedsAttentionCard, {
                    items: summary.needsAttention,
                    onItemAction: noop
                })
            }),
            /*#__PURE__*/ _jsxs(Box, {
                testId: TID.ColumnsGrid(),
                className: cn(styles.root, {
                    [styles.rootMobile]: isMobile
                }),
                children: [
                    /*#__PURE__*/ _jsxs(Column, {
                        testId: TID.LeftColumn(),
                        gap: 24,
                        gapMobile: 8,
                        className: styles.column,
                        children: [
                            /*#__PURE__*/ _jsx(BillingOverviewCard, {
                                customerId: clientId,
                                isArchived: isArchived,
                                onManageBilling: onManageBilling,
                                onBillClient: onBillClient,
                                onViewUpcomingInvoice: onViewUpcomingInvoice,
                                onViewAllOverdue: onViewAllOverdue
                            }),
                            /*#__PURE__*/ _jsx(AgreementsOverviewCard, {
                                customerId: clientId,
                                customerName: clientName,
                                isArchived: isArchived,
                                onCreateProposal: openNewProposal
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        testId: TID.RightColumn(),
                        gap: 24,
                        gapMobile: 8,
                        className: styles.column,
                        children: [
                            CRM_CONTACTS === true ? /*#__PURE__*/ _jsx(ContactsCard, {
                                clientId: clientId,
                                isArchived: isArchived
                            }) : /*#__PURE__*/ _jsx(ContactsCardOld, {
                                clientId: clientId,
                                isArchived: isArchived
                            }),
                            /*#__PURE__*/ _jsx(PaymentMethodsCard, {
                                clientId: clientId,
                                isArchived: isArchived,
                                onAddPaymentMethod: openAddPaymentMethodModal
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
